export enum SpecialRecommendationEnum {
	NONE = 'NONE',
	DEAD_TREE = 'DEAD_TREE'
}

export enum TypeOperationEnum {
	DEFAULT = 'DEFAULT',
	REMOVAL = 'REMOVAL',
	SUPPRESSION = 'SUPPRESSION'
}

export interface IHandlerOperation {
	_id?: string
	operation?: string
	instructions?: string
	description?: string
	legalFundamentation?: string
	enableInRelatory?: boolean
	color?: string
	gallery?: Array<IGallery | any>
	status?: string
	createdDate?: Date
	editedDate?: Date
	company?: string
	managementConfiguration?: IManagementConfiguration
	specialRecommendation?: SpecialRecommendationEnum
	typeOperation?: TypeOperationEnum
	sections?: Array<Section>
}

export class Section {
	public id?: number = 0
	public name: string = ''
	public description: string = ''
	public handlerOperationId?: string = ''
}

export interface IHandlerOperationAndMonitoring {
	operations: Array<IHandlerOperationConfiguration>
	manitoring: IManagementMonitoring
}

export interface IGallery {
	type: string
	string: string
	file?: any
}

export interface IHandlerOperationConfiguration {
	idMongo: string
	operation: string
	appEvaluator: boolean
	appInventor: boolean
	appOpportunity: boolean
	HandlerOperationManagementConfiguration: IManagementConfiguration
}

export interface IManagementConfiguration {
	preventive: Boolean
	predictive: Boolean
	corrective: Boolean
	intensive: Boolean
}

export interface IManagementMonitoring {
	preventive: number
	predictive: number
	corrective: number
	intensive: number
}
